import { useState } from "react";
import moment from "moment";

import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';

import HTMLPreview from "./HTMLPreview";
import CustomTableV2 from "../../../common/CustomTableV2";
import CustomModal from "../../../common/CustomModal";

function EmailSentLogs({ patient, id = "", className = "" }) {
    const [showModal, setShowModal] = useState(false);
    const [htmlPreview, setHtmlPreview] = useState("");
    return (
        <>
            <div className={className} id={id}>
                <h5>
                    Email History
                </h5>
                {
                    patient?.emailSentLogs?.length > 0 ? (
                        <CustomTableV2
                            title=""
                            description=""
                            store={{
                                list: patient?.emailSentLogs,
                                count: patient?.emailSentLogs?.length,
                            }}
                            table={{
                                headers: [

                                    { title: "#" },
                                    { title: "Email Type" },
                                    { title: "Email Address" },
                                    { title: "Date Sent" },
                                    { title: "Date Delivered" },
                                    { title: "Date Opened" },
                                    { title: "Date Clicked" },
                                    { title: "Date Registered" },
                                    { title: "" },
                                ],
                                body: (el, i) => {

                                    return (
                                        <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                            <td><h5>{i}</h5></td>
                                            <td><h5>{el?.email_type?.toUpperCase()}</h5></td>
                                            <td><h5>{el?.email_address}</h5></td>
                                            <td><h5>{el?.date_sent ? moment(el?.date_sent).format("MM/DD/YYYY") : "-"}</h5></td>
                                            <td><h5>{el?.date_delivered ? moment(el?.date_delivered).format("MM/DD/YYYY") : "-"}</h5></td>
                                            <td><h5>{el?.date_opened ? moment(el?.date_opened).format("MM/DD/YYYY") : "-"}</h5></td>
                                            <td><h5>{el?.date_clicked ? moment(el?.date_clicked).format("MM/DD/YYYY") : "-"}</h5></td>
                                            <td><h5>{el?.date_registered ? moment(el?.date_registered).format("MM/DD/YYYY") : "-"}</h5></td>
                                            <td className="preview-email-icon">
                                                {
                                                    el?.email_content && <Tooltip title="Preview Email" onClick={() => {
                                                        setHtmlPreview(el?.email_content);
                                                        setShowModal(true);
                                                    }}>
                                                        <IconButton>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                }

                                            </td>

                                        </tr>
                                    )
                                }
                            }}
                            actions={{
                            }}
                            withPagination={false}
                            withSearch={false}
                            defaultPerPage={100}
                        />
                    )
                        : <><em>-- no sent emails --</em></>
                }

            </div>

            <CustomModal
                size="m"
                toggle={setShowModal}
                show={showModal}
                title=""
                body={(
                    <div className="preview" dangerouslySetInnerHTML={{ __html: htmlPreview }} />
                )}
            />
        </>
    );
}

export default EmailSentLogs;